import AllTrapsActivityBarChart from './MCTCharts/1allTrapsActivityBarChart/1allTrapsActivityBarChart';
import TrapsActivityLineChart from './MCTCharts/2trapActivityLineChart/2trapActivityLineChart';
import MiceActivityDonutChart from './MCTCharts/3miceActivityDonutChart/3miceActivityDonutChart';
import MiceActivityTable from './MCTCharts/3miceActivityTable/MiceActivityTable';
import MiceToTrapActivityLineChart from './MCTCharts/4miceToTrapActivityLineChart/4miceToTrapsAcitivityLineChart';
import TotalTrapsCapturesChart from './MCTCharts/5totalTrapsCapturesChart/5totalTrapsCapturesChart';
import HeatmapChart from './MCTCharts/6heatmapChart/6HeatmapChart';

import { ObjectTraps } from 'api/analitics/types';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface PageProps {
  slug: string;
  trapType: TrapType;
  objectTraps: ObjectTraps;
}

const MCTPage: React.FC<PageProps> = ({ slug, trapType, objectTraps }) => {
  return (
    <>
      <div className="row my-3">
        <div className="col-xxl-12 my-2">
          <HeatmapChart slug={slug} type={trapType} />
        </div>
      </div>

      <div className="row my-3">
        <div className="col-xxl-6 my-2">
          <AllTrapsActivityBarChart slug={slug} type={trapType} objectTraps={objectTraps} />
        </div>
        <div className="col-xxl-6 my-2">
          <TrapsActivityLineChart slug={slug} type={trapType} objectTraps={objectTraps} />
        </div>
      </div>
      <div className="row my-3">
        <div className="col-xxl-6 my-2">
          <MiceActivityDonutChart slug={slug} type={trapType} objectTraps={objectTraps} />
        </div>
        <div className="col-xxl-6 my-2">
          <MiceActivityTable slug={slug} type={trapType} objectTraps={objectTraps} />
        </div>
      </div>
      <div className="row my-3">
        <div className="col-xxl-6 my-2">
          <MiceToTrapActivityLineChart slug={slug} type={trapType} objectTraps={objectTraps} />
        </div>
        {trapType !== TrapType.SRST && (
          <div className="col-xxl-6 my-2">
            <TotalTrapsCapturesChart slug={slug} objectTraps={objectTraps} />
          </div>
        )}
      </div>
    </>
  );
};

export default MCTPage;
